import {Grid, GridItem} from "@consta/uikit/Grid";
import {Button} from "@consta/uikit/Button";
import React, {useEffect, useState} from "react";
import "../css/pageBsi.css";
import {DragNDropField} from '@consta/uikit/DragNDropField';
import {Text} from '@consta/uikit/Text';
import GridBsiBsiList from "./component/grid.bsi.bsiList";
import ModalBsiPayload, {readFile} from "./component/modal.bsi.payload";
import ModalBsiDiagram from "./component/modal.bsi.diagram";
import {Tabs} from "@consta/uikit/Tabs";
import {IconPhoto} from "@consta/uikit/IconPhoto";
import {IconRing} from "@consta/uikit/IconRing";
import {IconComponent} from "@consta/uikit/Icon";
import {SnackCmp} from "../../component/snack.cmp";
import {ProcessingType} from "./component/modal.bsi.payload";
import http from "../../service/axiosConfig";
import {
    API_BSI_AUTO_SOURCE_DIAGRAM,
    API_BSI_AUTO_SOURCE_REFRESH,
    API_BSI_AUTO_SESSIONS,
    API_BSI_AUTO_SESSIONS_REFRESH,
    API_BSI_TEHSMART_ARCHIVE,
    API_BSI_TEHSMART_REFRESH,
    API_CONTRACTOR_CLOSURE_OPTIONS,
    API_DRAMATIQ_TASK_RESULT
} from "../../service/api.endpoint";

type Item = {
    name: string;
    image?: IconComponent;
};

const items: Item[] = [
    {
        name: "Загрузка",
        image: IconPhoto
    },
    {
        name: "Сервер",
        image: IconRing
    }
];

const PageBsi = () => {
    const [tabsValue, setTabsValue] = useState<Item | null>(items[0]);
    const [files, setFiles] = React.useState<File[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalDiagramOpen, setIsModalDiagramOpen] = useState(false);
    const [newRowData, setNewRowData] = useState<any>(null);
    const [bsiFileDiagram, setBsiFileDiagram] = useState<string | null>();
    const [bsiDiagramFileName, setBsiDiagramFileName] = useState<string>('');
    const [isDiagramFileReading, setIsDiagramFileReading] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [processingData, setProcessingData] = useState<ProcessingType[]>([]);

    useEffect(() => {
        document.title = 'АСПО.Контроль | БСИ';
    }, []);

    const handleModalClose = (value: any) => {
        setIsModalOpen(false);
        if (value && value !== false) {
            // value теперь это processingData (массив)
            if (Array.isArray(value) && value.length > 0) {
                setProcessingData(value);
                setShowSnackbar(true);
                setNewRowData(value); // Обновляем данные для таблицы

                // Скрываем снекбар через 4 секунды после последнего уведомления
                setTimeout(() => {
                    setShowSnackbar(false);
                    setProcessingData([]);
                }, 4000);
            }
        }
    };

    const handleDropFiles = (files: any) => {
        setFiles(files)
        setIsModalOpen(true)
    }

    const handleDropFilesDiagram = (files: any) => {
        const file = files?.[0]

        if (!file) {
            return
        }

        setBsiFileDiagram(null)
        setBsiDiagramFileName(file.name || '')
        setIsDiagramFileReading(true)
        setIsModalDiagramOpen(true)

        readFile(file)
            .then((contents: any) => {
                setBsiFileDiagram(contents)
            })
            .finally(() => setIsDiagramFileReading(false))
    }

    const handleModalDiagramClose = () => {
        setIsModalDiagramOpen(false);
        setBsiFileDiagram(null)
        setBsiDiagramFileName('')
        setIsDiagramFileReading(false)
    };


    return (
        <div className="bsi-page">
            <div className="bsi-page__header">
                <div>
                    <h1>БСИ</h1>
                    <p>Загрузка, проверка и просмотр данных по проходкам экипажей</p>
                </div>
                <div className="bsi-page__summary">
                    <span>TXT-файлы</span>
                    <strong>БСИ экипажей</strong>
                </div>
            </div>

            {tabsValue?.name === "Загрузка" &&
                (<Grid className="bsi-actions" cols="4" gap="m">
                    <GridItem col={2}>
                        <div className="bsi-upload-card">
                            <DragNDropField multiple={true}
                                            onDropFiles={(files) => handleDropFiles(files)}
                                            accept={['.txt']}>
                                {({openFileDialog}) => (
                                    <div className="bsi-drop-content">
                                        <div className="bsi-drop-icon">БСИ</div>
                                        <Text weight="black" size="l">
                                            Загрузить БСИ в систему
                                        </Text>
                                        <Text size="s" view="secondary">
                                            Перетащите один или несколько TXT-файлов экипажей. После проверки откроется окно подтверждения.
                                        </Text>
                                        <Button size='s' view="primary" onClick={openFileDialog} label="Выбрать файлы"/>
                                    </div>
                                )}
                            </DragNDropField>
                        </div>
                    </GridItem>
                    <GridItem col={2}>
                        <div className="bsi-upload-card bsi-upload-card--diagram">
                            <DragNDropField multiple={false}
                                            onDropFiles={(files) => handleDropFilesDiagram(files)}
                                            accept={['.txt']}>
                                {({openFileDialog}) => (
                                    <div className="bsi-drop-content">
                                        <div className="bsi-drop-icon bsi-drop-icon--diagram">График</div>
                                        <Text weight="black" size="l">
                                            Быстро открыть диаграмму
                                        </Text>
                                        <Text size="s" view="secondary">
                                            Для просмотра без загрузки в график выберите один TXT-файл БСИ.
                                        </Text>
                                        <Button size='s' view="secondary" onClick={openFileDialog} label="Открыть файл"/>
                                    </div>
                                )}
                            </DragNDropField>
                        </div>
                    </GridItem>
                </Grid>)}

            <div className="bsi-table-card">
                <div className="bsi-table-card__head">
                    <div>
                        <h2>{tabsValue?.name === "Загрузка"
                            ? 'Загруженные БСИ'
                            : tabsValue?.name === "Сервер"
                                ? 'БСИ с сервера'
                                : 'Автозагрузка БСИ'}</h2>
                        <p>{tabsValue?.name === "Загрузка"
                            ? 'История файлов, которые уже обработаны и доступны в системе'
                            : tabsValue?.name === "Сервер"
                                ? 'Данные, полученные напрямую с серверных устройств экипажей'
                                : 'Очередь сопоставления серверных БСИ со скважинами и графиком'}</p>
                    </div>
                    <Tabs
                        value={tabsValue}
                        size="s"
                        view="bordered"
                        linePosition="bottom"
                        fitMode="scroll"
                        onChange={({value}) => setTabsValue(value)}
                        items={items}
                        getItemLabel={(item) => item.name}
                    />
                </div>
                {tabsValue?.name === "Загрузка" &&
                    <GridBsiBsiList key="uploaded" newRowData={newRowData} fromUploaded={false}/>
                }
                {tabsValue?.name === "Сервер" &&
                    <>
                        <TehsmartServerPanel/>
                        <GridBsiBsiList key="server" newRowData={newRowData} fromUploaded={true}/>
                    </>
                }
                {tabsValue?.name === "Автозагрузка" &&
                    <AutoLoadPanel/>
                }
            </div>

            <ModalBsiPayload isOpen={isModalOpen}
                             onClose={handleModalClose}
                             files={files}
                             nodeData={null}/>
            {isModalDiagramOpen && (
                <ModalBsiDiagram isOpen={isModalDiagramOpen}
                                 onClose={handleModalDiagramClose}
                                 bsiFileDiagram={bsiFileDiagram}
                                 localFileName={bsiDiagramFileName}
                                 localFileReading={isDiagramFileReading}
                />
            )}

            {showSnackbar && processingData.length > 0 && (
                <SnackCmp
                    key={JSON.stringify(processingData)}
                    alertText={''}
                    processingData={processingData}
                    alertType={'normal'}
                />
            )}
        </div>
    )
}

function AutoLoadPanel() {
    const [rows, setRows] = useState<any[]>([])
    const [orgs, setOrgs] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [refreshing, setRefreshing] = useState(false)
    const [error, setError] = useState('')
    const [activeFilter, setActiveFilter] = useState('')
    const [totals, setTotals] = useState<any>({})
    const [dateFrom, setDateFrom] = useState(() => {
        const value = new Date()
        value.setDate(value.getDate() - 7)
        return value.toISOString().slice(0, 10)
    })
    const [dateTo, setDateTo] = useState(() => new Date().toISOString().slice(0, 10))
    const [selectedOrg, setSelectedOrg] = useState('')
    const [selectedShift, setSelectedShift] = useState('ALL')
    const [sourceDiagramData, setSourceDiagramData] = useState<any>(null)
    const [sourceDiagramInfo, setSourceDiagramInfo] = useState('')
    const [sourceDiagramLoading, setSourceDiagramLoading] = useState(false)
    const [isSourceDiagramOpen, setIsSourceDiagramOpen] = useState(false)

    const fetchOrgs = async () => {
        try {
            const response = await http.get(API_CONTRACTOR_CLOSURE_OPTIONS)
            setOrgs(response.data?.orgs || [])
        } catch (err) {
            setOrgs([])
        }
    }

    const fetchSessions = async () => {
        setLoading(true)
        setError('')
        try {
            const response = await http.get(API_BSI_AUTO_SESSIONS, {
                params: {
                    date_from: dateFrom || undefined,
                    date_to: dateTo || undefined,
                    org: selectedOrg || undefined,
                    shift: selectedShift,
                    limit: 5000,
                },
            })
            setRows(response.data?.results || [])
            setTotals(response.data?.totals || {})
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось получить сессии автозагрузки')
        } finally {
            setLoading(false)
        }
    }

    const refreshSessions = async () => {
        setLoading(true)
        setError('')
        try {
            await http.post(API_BSI_AUTO_SESSIONS_REFRESH, {
                date_from: dateFrom || undefined,
                date_to: dateTo || undefined,
                org: selectedOrg || undefined,
                shift: selectedShift,
                limit: 5000,
            })
            await fetchSessions()
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось собрать кандидатов автозагрузки')
        } finally {
            setLoading(false)
        }
    }

    const refreshAutoSource = async () => {
        setRefreshing(true)
        setError('')
        try {
            const response = await http.post(API_BSI_AUTO_SOURCE_REFRESH, {
                date_from: dateFrom || undefined,
                date_to: dateTo || undefined,
                org: selectedOrg || undefined,
                shift: selectedShift,
            })
            pollAutoSourceTask(response.data.requestId)
        } catch (err: any) {
            setRefreshing(false)
            setError(err.response?.data?.detail || 'Не удалось запустить отдельный опрос Tehsmart')
        }
    }

    const pollAutoSourceTask = async (requestId: string) => {
        try {
            const response = await http.get(API_DRAMATIQ_TASK_RESULT, {
                params: {requestId},
            })
            const task = response.data
            if (!task) {
                window.setTimeout(() => pollAutoSourceTask(requestId), 2000)
                return
            }
            if (task.status === 'ERROR') {
                setRefreshing(false)
                setError(task.error || 'Ошибка отдельного опроса Tehsmart')
                return
            }
            if (task.status === 'DONE') {
                setRefreshing(false)
                await refreshSessions()
                return
            }
            window.setTimeout(() => pollAutoSourceTask(requestId), 2000)
        } catch (err: any) {
            setRefreshing(false)
            setError(err.response?.data?.detail || 'Не удалось получить результат отдельного опроса')
        }
    }

    useEffect(() => {
        fetchOrgs()
        fetchSessions()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const filteredRows = activeFilter === 'PROBLEMS'
        ? rows.filter((item: any) => !['READY', 'FILE_CREATED', 'LOADED'].includes(item.status))
        : activeFilter
            ? rows.filter((item: any) => item.status === activeFilter)
            : rows
    const equipageGroups = Object.values(rows.reduce((acc: any, item: any) => {
        const equipageKey = `${item.org_id || item.org_name || 'org'}-${item.equipage_name || item.device_name || item.device_id}`
        if (!acc[equipageKey]) {
            acc[equipageKey] = {
                key: equipageKey,
                org: item.org_name || '—',
                equipage: item.equipage_name || item.device_name || '—',
                device: item.device_name || '—',
                wells: new Set(),
                count: 0,
                maxDepth: null,
                first: item,
            }
        }
        acc[equipageKey].count += item.rows_count || 0
        acc[equipageKey].wells.add(item.source_well || 'Без номера')
        const depth = normalizeDepth(item.max_depth)
        if (typeof depth === 'number') {
            acc[equipageKey].maxDepth = acc[equipageKey].maxDepth === null ? depth : Math.max(acc[equipageKey].maxDepth, depth)
        }
        return acc
    }, {})).sort((left: any, right: any) => right.count - left.count)

    const setFilter = (filter: string) => {
        setActiveFilter(activeFilter === filter ? '' : filter)
    }

    const openSourceDiagram = async (item: any) => {
        setSourceDiagramLoading(true)
        setSourceDiagramData(null)
        setSourceDiagramInfo(`${item.equipage_name || 'Экипаж'} · ${formatDate(item.work_date)} · ${item.source_well || 'Без номера'}`)
        setIsSourceDiagramOpen(true)
        try {
            const response = await http.get(API_BSI_AUTO_SOURCE_DIAGRAM, {
                params: {
                    device_id: item.device_id,
                    work_date: item.work_date,
                    source_deposit: item.source_deposit || '',
                    source_bush: item.source_bush || '',
                    source_well: item.source_well || '',
                    start_at: item.start_at || item.first_on_time || undefined,
                    end_at: item.end_at || item.last_on_time || undefined,
                },
            })
            setSourceDiagramData(response.data)
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось открыть график БСИ')
            setIsSourceDiagramOpen(false)
        } finally {
            setSourceDiagramLoading(false)
        }
    }

    return (
        <div className="bsi-auto">
            <div className="bsi-auto__toolbar">
                <div>
                    <h3>Скважины Tehsmart</h3>
                    <p>Отдельная логика автозагрузки: показывает все скважины из сырых серверных строк без изменения текущей загрузки БСИ.</p>
                </div>
                <div className="bsi-auto__actions">
                    <button type="button" className="bsi-auto__button bsi-auto__button--secondary" onClick={fetchSessions} disabled={loading || refreshing}>
                        {loading ? 'Загружаем...' : 'Обновить список'}
                    </button>
                    <button type="button" className="bsi-auto__button bsi-auto__button--secondary" onClick={refreshSessions} disabled={loading || refreshing}>
                        {loading ? 'Собираем...' : 'Собрать кандидатов'}
                    </button>
                    <button type="button" className="bsi-auto__button bsi-auto__button--primary" onClick={refreshAutoSource} disabled={loading || refreshing}>
                        {refreshing ? 'Опрос идет...' : 'Опросить Tehsmart'}
                    </button>
                </div>
            </div>

            <div className="bsi-auto__filters">
                <label>
                    Подрядчик
                    <select value={selectedOrg} onChange={(event) => setSelectedOrg(event.target.value)}>
                        <option value="">Все подрядчики</option>
                        {orgs.map((org: any) => (
                            <option key={org.id} value={org.id}>{org.name}</option>
                        ))}
                    </select>
                </label>
                <label>
                    С
                    <input type="date" value={dateFrom} onChange={(event) => setDateFrom(event.target.value)}/>
                </label>
                <label>
                    По
                    <input type="date" value={dateTo} onChange={(event) => setDateTo(event.target.value)}/>
                </label>
                <label>
                    Смена
                    <select value={selectedShift} onChange={(event) => setSelectedShift(event.target.value)}>
                        <option value="ALL">Все: 08:00-08:00</option>
                        <option value="DAY">1 смена: 08:00-20:00</option>
                        <option value="NIGHT">2 смена: 20:00-08:00</option>
                    </select>
                </label>
                <button type="button" onClick={fetchSessions} disabled={loading}>Показать</button>
            </div>

            <div className="bsi-auto__counters">
                <AutoCounter label="Всего" value={totals.total || rows.length} active={!activeFilter} onClick={() => setActiveFilter('')}/>
                <AutoCounter label="Готово" value={totals.ready || 0} active={activeFilter === 'READY'} onClick={() => setFilter('READY')} tone="green"/>
                <AutoCounter label="Проблемы" value={totals.problems || 0} active={activeFilter === 'PROBLEMS'} onClick={() => setFilter('PROBLEMS')} tone="red"/>
                <AutoCounter label="Файл создан" value={totals.file_created || 0} active={activeFilter === 'FILE_CREATED'} onClick={() => setFilter('FILE_CREATED')} tone="blue"/>
                <AutoCounter label="Загружено" value={totals.loaded || 0} active={activeFilter === 'LOADED'} onClick={() => setFilter('LOADED')} tone="gray"/>
            </div>

            {error && <div className="tehsmart-error">{error}</div>}
            {loading && <div className="tehsmart-note">Загружаем скважины Tehsmart...</div>}
            {refreshing && <div className="tehsmart-note">Идет отдельный опрос Tehsmart, текущая загрузка БСИ не затрагивается...</div>}

            <div className="bsi-auto-wells">
                <div className="bsi-auto-wells__head">
                    <div>
                        <h3>Экипажи и обработки за период</h3>
                        <p>Каждый номер скважины показывается отдельно. При будущей обработке один БСИ должен создаваться только для одной скважины.</p>
                    </div>
                    <span>{equipageGroups.length}</span>
                </div>
                <div className="bsi-auto-wells__list">
                    {equipageGroups.map((group: any) => (
                        <div key={group.key} className="bsi-auto-well">
                            <span>{group.org}</span>
                            <strong>{group.equipage}</strong>
                            <span>{group.device}</span>
                            <span>{Array.from(group.wells).join(', ')}</span>
                            <strong>{group.count}</strong>
                            <span>{formatDepth(group.maxDepth)}</span>
                        </div>
                    ))}
                    {!loading && equipageGroups.length === 0 && (
                        <div className="bsi-auto-table__empty">За выбранный период обработки не найдены</div>
                    )}
                </div>
            </div>

            <div className="bsi-auto-table">
                <div className="bsi-auto-table__row bsi-auto-table__row--head">
                    <span>Дата</span>
                    <span>Подрядчик</span>
                    <span>Экипаж</span>
                    <span>Прибор</span>
                    <span>Месторождение</span>
                    <span>Куст</span>
                    <span>Скважина</span>
                    <span>Строк</span>
                    <span>Макс. глубина</span>
                    <span>Первая точка</span>
                    <span>Последняя точка</span>
                    <span>Статус</span>
                    <span>Ответственный</span>
                    <span>Действие</span>
                </div>
                {filteredRows.map((item: any) => (
                    <div key={item.id} className={`bsi-auto-table__row is-${String(item.status || '').toLowerCase()}`}>
                        <span>{formatDate(item.work_date)}</span>
                        <span>{item.org_name || '—'}</span>
                        <span>{item.equipage_name || '—'}</span>
                        <span>{item.device_name || '—'}</span>
                        <span>{item.source_deposit || '—'}</span>
                        <span>{item.source_bush || '—'}</span>
                        <span><strong>{item.source_well || 'Без номера'}</strong></span>
                        <span>{item.rows_count || 0}</span>
                        <span>{formatDepth(item.max_depth)}</span>
                        <span>{formatDateTime(item.start_at || item.first_on_time)}</span>
                        <span>{formatDateTime(item.end_at || item.last_on_time)}</span>
                        <span title={item.reason || item.status_display || ''}>
                            <strong>{item.status_display || item.status}</strong>
                            {item.reason && <small>{item.reason}</small>}
                        </span>
                        <span>{item.source_people || '—'}</span>
                        <span>
                            <button type="button" className="bsi-auto-table__button" onClick={() => openSourceDiagram(item)}>
                                График
                            </button>
                        </span>
                    </div>
                ))}
                {!loading && filteredRows.length === 0 && (
                    <div className="bsi-auto-table__empty">Нет записей для выбранного фильтра</div>
                )}
            </div>

            {isSourceDiagramOpen && (
                <ModalBsiDiagram
                    isOpen={isSourceDiagramOpen}
                    onClose={() => setIsSourceDiagramOpen(false)}
                    diagramData={sourceDiagramData}
                    equipageInfo={sourceDiagramInfo}
                    localFileReading={sourceDiagramLoading}
                />
            )}
        </div>
    )
}

function AutoCounter({label, value, active, onClick, tone = ''}: any) {
    return (
        <button type="button" className={`bsi-auto-counter ${tone ? `is-${tone}` : ''} ${active ? 'is-active' : ''}`} onClick={onClick}>
            <span>{label}</span>
            <strong>{value}</strong>
        </button>
    )
}

function TehsmartServerPanel() {
    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [selectedDevice, setSelectedDevice] = useState<any>(null)
    const [archiveDate, setArchiveDate] = useState(() => new Date().toISOString().slice(0, 10))
    const [archiveData, setArchiveData] = useState<any>(null)
    const [archiveLoading, setArchiveLoading] = useState(false)
    const [archiveError, setArchiveError] = useState('')

    const rows = data?.results || []
    const totals = data?.totals || {}
    const groupedRows = groupBy(rows, 'token_org_name')

    const refreshStatus = async () => {
        setLoading(true)
        setError('')
        setData(null)
        try {
            const response = await http.post(API_BSI_TEHSMART_REFRESH)
            const requestId = response.data.requestId
            pollTask(requestId)
        } catch (err: any) {
            setLoading(false)
            setError(err.response?.data?.detail || 'Не удалось запустить обновление Tehsmart')
        }
    }

    const pollTask = async (requestId: string) => {
        try {
            const response = await http.get(API_DRAMATIQ_TASK_RESULT, {
                params: {requestId},
            })
            const task = response.data
            if (!task) {
                window.setTimeout(() => pollTask(requestId), 2000)
                return
            }
            if (task.status === 'ERROR') {
                setLoading(false)
                setError(task.error || 'Ошибка фоновой задачи Tehsmart')
                return
            }
            if (task.status === 'DONE') {
                setLoading(false)
                setData(task.data)
                return
            }
            window.setTimeout(() => pollTask(requestId), 2000)
        } catch (err: any) {
            setLoading(false)
            setError(err.response?.data?.detail || 'Не удалось получить результат обновления')
        }
    }

    const openArchive = async (device: any) => {
        setSelectedDevice(device)
        setArchiveData(null)
        setArchiveError('')
        setArchiveLoading(true)
        try {
            const response = await http.get(API_BSI_TEHSMART_ARCHIVE, {
                params: {
                    serialNo: device.serial_no,
                    date: archiveDate,
                    tokenOrgId: device.token_org_id,
                },
            })
            setArchiveData(response.data)
        } catch (err: any) {
            setArchiveError(err.response?.data?.error || 'Не удалось получить архив прибора')
        } finally {
            setArchiveLoading(false)
        }
    }

    useEffect(() => {
        if (selectedDevice) {
            openArchive(selectedDevice)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [archiveDate])

    return (
        <div className="tehsmart-panel">
            <div className="tehsmart-panel__head">
                <div>
                    <h3>Tehsmart Online</h3>
                    <p>Мониторинг приборов СКК-311 по подрядчикам. Архив загружается только при открытии прибора.</p>
                </div>
                <button type="button" onClick={refreshStatus} disabled={loading}>
                    {loading ? 'Обновляем...' : 'Обновить с Tehsmart'}
                </button>
            </div>

            {(data || loading || error) && (
                <div className="tehsmart-panel__body">
                    <div className="tehsmart-counters">
                        <TehsmartCounter label="Всего" value={totals.total || 0}/>
                        <TehsmartCounter label="На связи" value={totals.online || 0} accent="green"/>
                        <TehsmartCounter label="За сутки" value={totals.stale || 0} accent="yellow"/>
                        <TehsmartCounter label="Молчат" value={totals.silent || 0} accent="red"/>
                        <TehsmartCounter label="Нет в АСПО" value={totals.unknown_devices || 0} accent="blue"/>
                        <TehsmartCounter label="Не привязаны" value={totals.not_linked || 0} accent="gray"/>
                        <TehsmartCounter label="Server mode выкл." value={totals.server_mode_off || 0} accent="orange"/>
                    </div>

                    {loading && <div className="tehsmart-note">Обновляем данные Tehsmart...</div>}
                    {error && <div className="tehsmart-error">{error}</div>}
                    {data?.errors?.length > 0 && (
                        <div className="tehsmart-error">
                            {data.errors.map((item: any) => (
                                <span key={item.org_id}>{item.org_name}: {item.message}</span>
                            ))}
                        </div>
                    )}

                    {rows.length > 0 && (
                        <div className="tehsmart-groups">
                            {Object.entries(groupedRows).map(([orgName, items]: any) => (
                                <div key={orgName} className="tehsmart-group">
                                    <div className="tehsmart-group__head">
                                        <strong>{orgName}</strong>
                                        <span>{items.length}</span>
                                    </div>
                                    <div className="tehsmart-table">
                                        <div className="tehsmart-table__row tehsmart-table__row--head">
                                            <span>Прибор</span>
                                            <span>Экипаж</span>
                                            <span>Последний сигнал</span>
                                            <span>Глубина</span>
                                            <span>Статус</span>
                                            <span>АСПО</span>
                                        </div>
                                        {items.map((item: any) => (
                                            <button
                                                key={item.id}
                                                type="button"
                                                className={`tehsmart-table__row is-${String(item.status || '').toLowerCase()}`}
                                                onClick={() => openArchive(item)}
                                            >
                                                <span>{item.serial_no}</span>
                                                <span>{item.equipage_name || 'Не привязан'}</span>
                                                <span>{formatDateTime(item.last_on_time)}</span>
                                                <span>{formatDepth(item.depth)}</span>
                                                <span>{item.status_display}</span>
                                                <span>{item.is_known_device ? (item.equipage_server_mode ? 'server mode' : 'есть') : 'нет'}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {selectedDevice && (
                <div className="tehsmart-modal-overlay" onClick={() => setSelectedDevice(null)}>
                    <div className="tehsmart-modal" onClick={(event) => event.stopPropagation()}>
                        <div className="tehsmart-modal__head">
                            <div>
                                <h3>Прибор {selectedDevice.serial_no}</h3>
                                <p>{selectedDevice.token_org_name} · {selectedDevice.equipage_name || 'экипаж не привязан'}</p>
                            </div>
                            <button type="button" onClick={() => setSelectedDevice(null)}>Закрыть</button>
                        </div>
                        <div className="tehsmart-modal__toolbar">
                            <label>
                                Дата архива
                                <input
                                    type="date"
                                    value={archiveDate}
                                    onChange={(event) => setArchiveDate(event.target.value)}
                                />
                            </label>
                            <button type="button" onClick={() => openArchive(selectedDevice)} disabled={archiveLoading}>
                                {archiveLoading ? 'Загружаем...' : 'Обновить день'}
                            </button>
                        </div>
                        {archiveError && <div className="tehsmart-error">{archiveError}</div>}
                        {archiveLoading && <div className="tehsmart-note">Загружаем архив прибора...</div>}
                        {archiveData && (
                            <div className="tehsmart-archive">
                                <div className="tehsmart-archive__summary">
                                    <TehsmartInfo label="Строк" value={archiveData.summary?.rows_total}/>
                                    <TehsmartInfo label="Макс. глубина" value={formatDepth(archiveData.summary?.max_depth)}/>
                                    <TehsmartInfo label="Месторождение" value={archiveData.summary?.area || '—'}/>
                                    <TehsmartInfo label="Куст" value={archiveData.summary?.bush || '—'}/>
                                    <TehsmartInfo label="Скважина" value={archiveData.summary?.well || '—'}/>
                                    <TehsmartInfo label="Ответственный" value={archiveData.summary?.people || '—'}/>
                                </div>
                                <DepthChart points={archiveData.points || []}/>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

function TehsmartCounter({label, value, accent = ''}: any) {
    return (
        <div className={`tehsmart-counter ${accent ? `is-${accent}` : ''}`}>
            <span>{label}</span>
            <strong>{value}</strong>
        </div>
    )
}

function TehsmartInfo({label, value}: any) {
    return (
        <div className="tehsmart-info">
            <span>{label}</span>
            <strong>{value ?? '—'}</strong>
        </div>
    )
}

function DepthChart({points}: any) {
    const cleanPoints = (points || [])
        .map((item: any) => ({...item, depth: normalizeDepth(item.depth)}))
        .filter((item: any) => typeof item.depth === 'number')
    if (cleanPoints.length < 2) {
        return <div className="tehsmart-chart tehsmart-chart--empty">Недостаточно точек для графика</div>
    }
    const width = 900
    const height = 220
    const maxDepth = Math.max(...cleanPoints.map((item: any) => item.depth || 0), 1)
    const linePoints = cleanPoints.map((item: any, index: number) => {
        const x = (index / (cleanPoints.length - 1)) * width
        const y = height - ((item.depth || 0) / maxDepth) * (height - 20) - 10
        return `${x.toFixed(1)},${y.toFixed(1)}`
    }).join(' ')

    return (
        <div className="tehsmart-chart">
            <div className="tehsmart-chart__head">
                <strong>Глубина</strong>
                <span>макс. {formatDepth(maxDepth)} м · точек {cleanPoints.length}</span>
            </div>
            <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
                <polyline points={linePoints} fill="none" stroke="#175cd3" strokeWidth="3"/>
            </svg>
        </div>
    )
}

function groupBy(rows: any[], key: string) {
    return rows.reduce((acc: any, item: any) => {
        const groupKey = item[key] || 'Без группы'
        if (!acc[groupKey]) acc[groupKey] = []
        acc[groupKey].push(item)
        return acc
    }, {})
}

function formatDateTime(value: string | null) {
    if (!value) return '—'
    return new Date(value).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })
}

function formatDate(value: string | null) {
    if (!value) return '—'
    return new Date(value).toLocaleDateString('ru-RU')
}

function normalizeDepth(value: any) {
    if (value === null || value === undefined || value === '') return null
    const numberValue = Number(value)
    if (Number.isNaN(numberValue)) return null
    return Math.abs(numberValue) >= 10000 ? numberValue / 100 : numberValue
}

function formatDepth(value: any) {
    const depth = normalizeDepth(value)
    if (depth === null) return '—'
    return depth.toFixed(depth % 1 === 0 ? 0 : 2)
}

export default PageBsi;
